import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';

import styles from './searcher.module.css';

const SearcherOperators = ({ items }) => {
  const { t } = useTranslation();
  return Array.isArray(items) ? (
    <div className={styles.operators}>
      <span>{t('hotel.operators')}: </span>
      <span>{items.join(', ')}</span>
    </div>
  ) : null;
};

SearcherOperators.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string.isRequired),
};

SearcherOperators.defaultProps = {
  items: null,
};

export default SearcherOperators;
